import { useSelector } from 'react-redux'
import { StateExtended } from '../../interfaces/StateExtended'


export function useCompanyListSelector() {
    const companyList: any | null = useSelector((state: StateExtended) => state.company.companyList)
    return companyList
}